/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

// NOTE: long names cause red screen.  eg: createPostRequest
// name the functions different than the constants, or the Saga will not be called

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  createOptions: ["options"],
  createOptionsSuccess: ["ignore"],
  createRepost:  ["postId", "post"],
  createRequest: ["post", "files"],
  createSuccess: ["post"],
  createFailure: ["error"],
  createProgress: ["detail"]
})

export const CreatePostTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  post: null,
  creating: null,
  kind: null,
  error: null,
  progress: 0,
  modified: null,
  lastCreation: null,
  basePostWallOptions: {
    DEV: __DEV__,
    gridShowNavigation: false, // transparent
    pauseHiddenVideos: true,
    reduceHiddenVideos: false,
    debugBackgrounds: false,
    showHeader: true,
    showFooter: true,
    showComments: true,
    useFooterImages: true,
    showOverlayIcons: true,
    getExtendedData: true,
    forceSquare: false,
    useRowComponent: false,
    preloadLargeImages: false,
    enableCreatePostBtn: true,
    useCache: false,
    enableVideo: true,
    useVideoPosterFile: true,
    preloadVideoBeforePlaying: true,
    playWithoutControls: false,
    alwaysMute: false,
    enableVideoPauseMute: true,
    useOnScroll: true,
    useNewLayoutProvider: true,
    loadingOpacity: 0.0,
    listRenderAheadOffset: 1000,
    gridRenderAheadOffset: 1000,
    useShoppableTagging: true,
    useShoppableExplora: true,
    useShoppableShopIt: true,
    ignore: false, // keep
    skipAlbumArt: false,
    skipSongAnimation: false,
    pauseSongPlayback: false,
    pauseMusicMarquee: false,
    pauseMusicLottie: false,
    pauseMusicRotation: false,
    stopBlinkingEye: false,
    noLongVideoPlayButton: false,
    disableVideos: false,
  }
})

/* ------------- Reducers ------------- */

// set options
export const options = (state, action) => {
  const { options } = action
  console.tron.log("CreatePostRedux new options: " + JSON.stringify(options));
  return state.merge({ basePostWallOptions: options })
}

export const optionsSuccess = (state, action) => {
  // console.tron.log("CreatePostRedux createSuccess");
  // const { post } = action
  const newOptions = Object.assign({}, state.basePostWallOptions, {ignore: true})
  return state.merge({ basePostWallOptions: newOptions }) // might need to more fully fake a full redux/saga process
}



// create post
export const request = (state, action) => {
  // console.tron.log("CreatePostRedux createRequest");
  return state.merge({ creating: true, kind: 'post', progress: 0, error: null, post: null, modified: (new Date()).getTime() })
}

// create repost
export const repost = (state, action) => {
  // console.tron.log("CreatePostRedux createRequest");
  return state.merge({ creating: true, kind: 'repost', progress: 0, error: null, post: null, modified: (new Date()).getTime() })
}

// successful post creation
export const success = (state, action) => {
  // console.tron.log("CreatePostRedux createSuccess");
  const { post } = action
  const now = (new Date()).getTime()
  return state.merge({ creating: false, error: null, progress: 1, post: post, lastCreation: now, modified: now })
}

// failed to create post
export const failure = (state, action) => {
  console.tron.display({
    name: 'PostsRedux failure',
    preview: 'action',
    value: {
      action: action
    }
  })
  const { error } = action
  return state.merge({ creating: false, error: error, modified: (new Date()).getTime() })
}

export const progress = (state, action) => {
  const { detail } = action
  return state.merge({ progress: detail, modified: (new Date()).getTime() })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CREATE_OPTIONS]: options,
  [Types.CREATE_OPTIONS_SUCCESS]: optionsSuccess,
  [Types.CREATE_REPOST]: repost,
  [Types.CREATE_REQUEST]: request,
  [Types.CREATE_SUCCESS]: success,
  [Types.CREATE_FAILURE]: failure,
  [Types.CREATE_PROGRESS]: progress
})
